let commonUrl = "http://ouchn-book.ouchn.airlib.com";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl